/**
 * @desc 国内电商sn码防伪查询
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(snCode: string | number, options?: any) {
  return updateResponse(
    http(URL + `/stockSnDetail/antiCounterfeitingQuery/${snCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
